export class TokenManager {
  public static token: String;

  constructor() {
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/tokenManager.ts